<template lang="pug">
.schedule-meeting-modal
    .modal-container.flex-center
        template(v-if="selectedEvent && selectedEvent.eventType === CalendarEvents.EventType.TrainingRequest")
            .progress-bar
                .grey-bar
                .progress-icon.info(:class="{reached: mode >= SetupStage.CONTACT, current: mode == SetupStage.CONTACT}")
                    //- include ../resources/icons/info.svg
                    .step-name Contact
                .progress-icon.dog(:class="{reached: mode >= SetupStage.TYPE, current: mode == SetupStage.TYPE}")
                    //- include ../resources/icons/dog.svg
                    .step-name Services
                .progress-icon.calendar(:class="{reached: mode >= SetupStage.DATE, current: mode == SetupStage.DATE}")
                    //- include ../resources/icons/calendar.svg
                    .step-name Date
                
                
            .content.flex-center
                template(v-if="mode == SetupStage.CONTACT")
                    .content__heading Contact the customer
                    .content__options
                        .phone-number(v-if="eventUser?.phone") #[strong Customer Phone Number:] {{ eventUser?.phone }}
                        .email(v-if="eventUser?.email") #[strong Customer Email:] {{ eventUser?.email }}
                        .no-contact(v-if="!eventUser?.email && !eventUser?.phone ") Customer has no provided contact info
                        .actions
                            button.g-primary(@click="deleteRequest") Delete request
                template(v-else-if="mode == SetupStage.TYPE")
                    .content__heading Determine training method
                    .content__select Select the type of training they need TODO
                        
                template(v-else-if="mode == SetupStage.DATE")
                    .content__heading Establish pickup and dropoff date/times
                    .content__calendar
                        CalendarPicker(v-model:dropOffTime="startDateTime" v-model:pickUpTime="endDateTime")
            .schedule-buttons.flex-center
                button.g-primary(@click="$emit('close')") Cancel
                button.g-outline.continue(:disabled="disableContinue" @click="progressStage") Continue
        template(v-else)
            .content Event: {{ selectedEvent }}
            .schedule-buttons.flex-center
                button.g-primary(@click="$emit('close')") Cancel

</template>

<script lang="ts" setup>
// import TimeslotPicker from './timeslot-picker.vue'
import CalendarPicker from './calendar-picker.vue'
import { ref, computed } from 'vue'
import { CalendarEvents } from '@busy-human/k9-library';
import { useCalendarEvents } from '@/store/calendarEvents'
import { useUserspace } from '@/store/useUsers';
import { DataInstance } from '@busy-human/gearbox'

const calendarEvents = useCalendarEvents();
const userspaces = useUserspace();

type Props = {
    selectedEvent: DataInstance<CalendarEvents.Model>
}

const props = defineProps<Props>()

type Emits = {
    (e: 'close'): void
}
const emit = defineEmits<Emits>();

enum SetupStage {
    CONTACT = 1,  
    TYPE = 2,
    DATE = 3,
}

namespace SetupStage {
    export function before(value: SetupStage): SetupStage{
        if(Object.values(SetupStage).some((v)=>v === value-1))
            return value - 1
        else
            return value
    }
    export function after(value: SetupStage): SetupStage{
        if(Object.values(SetupStage).some((v)=>v === value+1))
            return value + 1
        else
            return value
    }
}
let mode = ref(SetupStage.CONTACT)

enum DogSelectType {
    REGISTER = 1,
    EXISTING = 2,
}

// User Inputs
const startDateTime = ref<string | null>(null)
const endDateTime = ref<string | null>(null)

const eventUser = computed(() => {
    if(props.selectedEvent.userId)
        return userspaces.users[props.selectedEvent.userId]
})

const disableContinue = computed(() => {
    let disable = false;

    return disable
})

const progressStage = () => {
    if(mode.value === SetupStage.DATE){
        updateTrainingRequest()
    }else
        mode.value = SetupStage.after(mode.value)
}

const updateTrainingRequest = async () => {
    let tmp = {...props.selectedEvent}

    tmp.startTime = startDateTime.value!
    tmp.endTime = endDateTime.value!
    tmp.eventType = CalendarEvents.EventType.Training
    //TODO: Record the type of training method they're using on the calendarevent object

    await calendarEvents.updateCalendarEvent(tmp)
    emit('close')
}

const deleteRequest = async () => {
    await calendarEvents.deleteCalendarEvent(props.selectedEvent.$id)
    emit('close')
}

</script>

<style lang="scss">
.schedule-meeting-modal {
    width: 100%;
    height: 100%;
    z-index: 1;

    .modal-container {
        width: clamp(750px, 45%, 900px);
        height: clamp(600px, 50%, 800px);
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 2;
        border-radius: 1rem;
        border: 1px solid black;
        background-color: white;

        .progress-bar {
            width: 80%;
            height: 15%;

            display: flex;
            justify-content: space-between;
            align-items: center;

            position: relative;

            .grey-bar{
                left: 5%;
                position: absolute;
                width: 90%;
                height: 5px;
                background: #D2D2D2;
                z-index: -1;
            }

            .progress-icon{
                $icon-size: 35px;
                width: $icon-size;
                height: $icon-size;
                border-radius: 100%;
                background: #000013;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                position: relative;

                svg path{
                    fill: #5A5A5A;
                }

                &.current{
                    background: #A70024
                }

                &.reached{
                    svg path{
                        fill: #FFFFFF;
                    }
                }

                .step-name{
                    top: 35px;
                    position: absolute;
                }
            }
        }
        .content {
            width: 100%;
            height: 65%;
            justify-content: space-around;

            &__heading {
                font-size: 2.5rem;
            }
            &__options {
                width: 80%;
                padding-bottom: 2rem;
                box-sizing: border-box;

                .actions{
                    margin-top: 2rem;
                    display: flex;
                    justify-content: center;
                }
            }

            &__calendar {
                width: 90%;
                height: 80%;
                padding-bottom: 2rem;
                box-sizing: border-box;
                display: flex;

                .calendar-placeholder {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 2.5rem;
                    background-color: lightblue;
                }
            }

            &__dog-input{
                width: 70%;
                height: 10%;
                box-sizing: border-box;
                display: flex;
                justify-content: space-between;
                gap: 0.5rem;
                border-bottom: 1px solid #A70024;

                .dog-input-option{
                    padding: 0.5rem;
                    padding-bottom: 0;
                    border: 1px solid #A70024;
                    margin-bottom: -1px;

                    cursor: pointer;

                    &:hover{
                        background: #a700245e
                    }

                    &.selected{
                        border-bottom: 1px solid white;
                    }
                }
            }

            &__form {
                width: 70%;
                height: 70%;
                padding-bottom: 2rem;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                gap: 0.5rem;

                &--input {
                    height: clamp(80px, 25%, 100px);
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    .label {
                        padding-bottom: 0.5rem;
                    }
                    .info {
                        height: 33px;
                        border: 1px solid red;
                        border-radius: 1rem;
                        padding-left: 0.5rem;

                        &:focus {
                            outline: none;
                            border: 3px solid red;
                        }
                    }
                }
            }
        }
        .schedule-buttons {
            width: 100%;
            height: 20%;
            flex-direction: row;
            justify-content: space-around;

            .continue{
                &:disabled{
                    background-color: rgb(202, 202, 202);
                    color: black;
                    border-color: black;
                    cursor: not-allowed;
                }
            }
        }
    }
}
</style>